import IconsTextNavigation from 'components/global/IconsTextNavigation'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import RoundModal from '../Modals/RoundModal'

const Rounds: React.FC = () => {
  const { roundsModal, setRoundsModal, leagueData } = leagueEventStore(
    store => ({
      roundsModal: store.roundsModal,
      setRoundsModal: store.setRoundsModal,
      leagueData: store.leagueData,
    }),
  )

  console.log(leagueData, 'leagueData in rounds....')

  return (
    <>
      <div onClick={() => setRoundsModal(true)}>
        <IconsTextNavigation
          iconName="Target"
          heading="Rounds"
          isCompleted={leagueData.statuses.roundRobinsStatuses.rounds}
        />
      </div>

      {roundsModal && <RoundModal />}
    </>
  )
}

export default Rounds
